import React, { Component } from 'react'
import { compose } from 'recompose'

import { invitedParticipants as invitedParticipantsApi } from '../../../redux/modules/api/tasks'
import { meta } from 'helpers/decorators'
import { FilterTasksInvitedParticipants } from '../../filters'
import { connect } from 'react-redux'
import { modal } from '../../../redux/modules/app'
import { TasksInvitedParticipantsTable } from '../../../components/sections/tasks'
import { apiTasksInvitedParticipants } from 'helpers/decorators/api'
import PropTypes from 'prop-types'
import BulkInvitedParticipants from '../../bulkChange/BulkInvitedParticipants/BulkInvitedParticipants'

const enhance = compose(
  meta({
    title: 'Invited Participants',
    intlKey: 'pageTitle.invited_participants'
  }),
  apiTasksInvitedParticipants({
    list: true,
    useCommonLimit: true,
    updateTasks: true
  }),
  connect(
    ({ auth }) => ({
      activeOrganization: auth.organization,
      user: auth.user
    }),
    { setFilter: invitedParticipantsApi.setTasksInvitedParticipantsFilter, modal }
  )
)

class TasksInvitedParticipants extends Component {
  static propTypes = {
    tasks: PropTypes.object.isRequired
  }

  render() {
    const {
      tasks
    } = this.props
    const selectedIds = tasks.selectedIds || []

    return (
      <>
        <FilterTasksInvitedParticipants />
        <BulkInvitedParticipants selectedIds={selectedIds} />
        <TasksInvitedParticipantsTable {...this.props} />
      </>
    )
  }
}

export default enhance(TasksInvitedParticipants)
